<template >
  <div class="mainbody">
    <div style="padding: 16px 32px 16px 0px">
      <span class="title">校友会活动</span>
      <el-button type="primary" size="small" style="float: right" @click="addActivity()">新建</el-button>
    </div>
    <div class="tableInfo">
      <el-table :data="data_list">
        <el-table-column prop="id" label="编号" min-width="1"></el-table-column>
        <el-table-column prop="title" label="活动名称" min-width="3"></el-table-column>
        <el-table-column label="活动分类" min-width="2">
          <template slot-scope="scope">
            <p style="white-space: pre-line">
              {{ scope.row.classify }}
            </p>
          </template>
        </el-table-column>
        <el-table-column prop="status.cn" label="状态" min-width="1"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" min-width="2"></el-table-column>
        <el-table-column prop="operating" label="操作" min-width="1" align="left">
          <template slot-scope="scope">
            <el-button class="operateText" size="mini" type="text" @click="activityEdit(scope.row)">编辑</el-button>
            <el-button class="operateText" size="mini" type="text" @click="activityDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :key="elementui_page_key"
        class="elPagination"
        background
        layout="prev, pager, next"
        :page-size="pageMaxSize"
        :page-count="pageCount"
        :current-page="currentPage"
        @current-change="currentChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import * as Utils from '@/utils/utils.js'
import { URL_PATH, LIST_PAGE_MAX_SIZE } from '@/config/config'

export default {
  components: {},
  data() {
    return {
      urlPath: URL_PATH,
      data_list: [], //数据列表
      elementui_page_key: 0,
      pageCount: 0, // 所有页数
      pageMaxSize: LIST_PAGE_MAX_SIZE,
      currentPage: 1
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList: function () {
      this.$api
        .associationActivityList({
          token: localStorage.getItem('token'),
          association_id: this.$route.query.id,
          page: this.currentPage,
          limit: this.pageMaxSize
        })
        .then(({ data }) => {
          let current_page = Utils.listPage(data, this.currentPage)
          if (current_page) {
            this.currentPage = current_page
            this.getList()
          }
          this.pageCount = data.Data.pageCount
          this.data_list = data.Data.model
          this.data_list.forEach(info => {
            info.classify = ''
            info.association.forEach(asso => {
              info.classify += asso.title + '\n'
            })
            // info.status = info.status == "Y" ? "已发布" : "未发布";
            info.createTime = Utils.dateFormat(info.create_time * 1000)
          })
        })
        .catch(({ error }) => {})
    },
    currentChange(val) {
      this.elementui_page_key++
      this.currentPage = val
      this.getList()
    },
    // 新建活动
    addActivity() {
      this.$router.push({
        path: '/wxapp/association_activitys_add',
        query: {
          association_id: this.$route.query.id
        }
      })
    },
    // 编辑活动
    activityEdit(row) {
      this.$router.push({
        path: '/wxapp/association_activitys_add',
        query: {
          id: row.id
        }
      })
    },
    // 删除活动
    activityDelete(row) {
      this.$confirm('是否删除此校友会活动?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.$api
            .associationDelActivity({
              token: localStorage.getItem('token'),
              id: row.id
            })
            .then(({ data }) => {
              this.getList()
            })
            .catch(({ error }) => {})
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="less" scoped>
.mainbody {
  // overflow: hidden;
  background-color: #ffffff;
  border-radius: 5px;
  padding-bottom: 58px;
}
.mainbody .title {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.85);
  padding: 16px 32px;
}
.mainbody .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
.mainbody .tableInfo {
  box-sizing: border-box;
  margin-left: 32px;
  margin-right: 32px;
}
</style>


// WEBPACK FOOTER //
// src/components/association/associationActivitys.vue